import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'
import Widget from '@/components-latest/primitives/Widget'
import ReviewStars from '@/components-latest/ui/PerformancePage/ReviewStars'

import Styles from './ReviewAverage.module.scss'

interface IReviewAverageProps {
  label: string
  onAction?: () => void
  value: number
}

const ReviewAverage: React.FC<IReviewAverageProps> = ({
  label,
  onAction,
  value
}) => {
  const { t } = useTranslation()

  const hasData = value !== -1

  return (
    <div
      data-testid={`review-average-${label}`}
      className={Styles.reviewAverage}>
      <div className={Styles.centeredRow}>
        <ReviewStars rating={value} />
        {hasData ? (
          <Text variant="title-1">
            {value.toFixed(1)}{' '}
            <Text asChild variant="title-3" className={Styles.grey}>
              <span>/ 5</span>
            </Text>
          </Text>
        ) : (
          <Text asChild variant="title-3" className={Styles.grey}>
            <span>{t('performance.reviews.empty')}</span>
          </Text>
        )}
      </div>
    </div>
  )
}

export default ReviewAverage
